import { FC } from 'react';

type HOC = (C: FC<any>) => FC<any>;

export function compose<P>(...args: (HOC | any)[]) {
  return function (C: FC<any>): FC<P> {
    return args.reduce((Wrapped, Wrapper) => Wrapper(Wrapped) as FC<P>, C);
  };
}
